import React from 'react';

/* Squelette de l'ossature admin, affiché pendant la vérification de session.
   Un spinner plein écran laissait la page vide puis la faisait apparaître d'un
   bloc ; ici la barre latérale, l'en-tête et la zone de contenu sont déjà en
   place, seul leur remplissage arrive après. */
const AppShellSkeleton: React.FC = () => (
  <div className="flex min-h-screen bg-gray-50">
    <aside className="hidden w-64 shrink-0 flex-col border-r border-gray-100 bg-white lg:flex">
      <div className="border-b border-gray-100 p-5">
        <div className="flex items-center space-x-2.5">
          <div className="h-8 w-8 shrink-0 animate-pulse rounded-lg bg-gray-100" />
          <div className="h-5 w-28 animate-pulse rounded bg-gray-100" />
        </div>
      </div>

      <div className="space-y-1.5 p-3">
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className="flex items-center gap-3 px-2 py-2">
            <div className="h-5 w-5 shrink-0 animate-pulse rounded bg-gray-100" />
            <div
              className="h-3.5 animate-pulse rounded bg-gray-100"
              style={{ width: `${52 + ((index * 13) % 40)}%` }}
            />
          </div>
        ))}
      </div>
    </aside>

    <div className="flex min-w-0 flex-1 flex-col">
      <header className="border-b border-gray-200 bg-white px-4 py-4 lg:px-6">
        <div className="flex items-center justify-between">
          <div>
            <div className="h-6 w-40 animate-pulse rounded bg-gray-100" />
            <div className="mt-2 h-3.5 w-56 max-w-full animate-pulse rounded bg-gray-100" />
          </div>
          <div className="flex items-center space-x-3">
            <div className="h-9 w-9 animate-pulse rounded-lg bg-gray-100" />
            <div className="h-9 w-9 animate-pulse rounded-full bg-gray-100" />
          </div>
        </div>
      </header>

      <main className="flex-1 space-y-6 p-4 lg:p-6">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="rounded-2xl bg-white p-5 shadow-[0_1px_2px_rgb(19_21_26/0.04)]">
              <div className="mb-3 h-3 w-24 animate-pulse rounded bg-gray-100" />
              <div className="h-7 w-16 animate-pulse rounded bg-gray-100" />
            </div>
          ))}
        </div>

        <div className="h-64 animate-pulse rounded-2xl bg-white shadow-[0_1px_2px_rgb(19_21_26/0.04)]" />
      </main>
    </div>
  </div>
);

export default AppShellSkeleton;
